<template lang="pug">
  .section#company
      p(v-if="company") {{company.name}}

</template>

<script>
export default {
  name: "CompanyDisplay",
  props: {
    company: null
  }
};
</script>

<style scoped lang="less">
#company {
  padding-top: 1rem;
  padding-bottom: 0;
  text-align: left;
  background-color: #333;
  color: #f78f30;
}
</style>
